<script setup lang="ts">
import { showToast } from 'vant'
import CustomDialog from '@/components/CustomDialog.vue'
import { useApi } from '@/composables/useApi'
import { useMusicAuthDialog } from '@/composables/useMusicAuthDialog'
import { getDeviceListByUserId } from '@/api/device'
import { NETEASE_OAUTH } from '@/pages/Content/utils/constants'
import { useAppParams } from '@/stores/app'
import { openURLToRN } from '@/bridge'
import { appConfig } from '@/config/appConfig'

defineOptions({ name: 'MusicAuthDialog' })

// ---- App params ----
const appParams = useAppParams()
// silent: 设备列表查询失败不弹默认 Toast（与原 Search 页一致，由下方 handleBind 自行提示）
const { executeImmediate: runGetDeviceList } = useApi(getDeviceListByUserId, null, { immediate: false, silent: true })
const { visible, close } = useMusicAuthDialog()

// 绑定网易云音乐：先校验设备，再构建 OAuth 授权 URL 跳转（逻辑迁自 Search 页 handleBind）
async function handleBind() {
  const data = await runGetDeviceList()
  if (!data?.length) {
    showToast({ message: '请先绑定设备后再授权' })
    return
  }
  const model = 'app'
  const state = `auth_netease_music_${Math.random().toString(36).substring(5, 15)}`
  const tomCatDomain = appConfig.apiBaseUrl
  const redirectUrl = encodeURIComponent(
    NETEASE_OAUTH.callbackOrigin +
      '?token=' +
      (appParams.token || '') +
      '&userId=' +
      (appParams.user_info?.userId || '') +
      '&appVersion=' +
      (appParams.version || '1.0.0') +
      '&model=' +
      model +
      '&tomCatDomain=' +
      tomCatDomain,
  )
  const authUrl =
    NETEASE_OAUTH.authorizeUrl +
    '?clientId=' +
    NETEASE_OAUTH.clientId +
    '&clientType=' +
    NETEASE_OAUTH.clientType +
    '&redirectUrl=' +
    redirectUrl +
    '&state=' +
    state
  close()
  openURLToRN(authUrl)
}
</script>

<template>
  <CustomDialog
    :visible="visible"
    title="音乐授权"
    content="请绑定网易云音乐，畅听海量音乐"
    cancel-text="暂不绑定"
    confirm-text="去绑定"
    @cancel="close"
    @confirm="handleBind"
  />
</template>
